import React, { useEffect, useState } from "react";
import api from "./api";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api
      .get(`${process.env.REACT_APP_API_URL}/products`, { withCredentials: true })
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Błąd ładowania produktów", err));
  }, []);

  const totalValue = products.reduce(
    (sum, p) => sum + Number(p.price || 0) * Number(p.quantity || 0),
    0
  );

  const top10 = [...products]
    .sort((a, b) => Number(b.price || 0) - Number(a.price || 0))
    .slice(0, 10);

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-center text-md-start">📊 Podsumowanie wyceny</h2>

      <div className="row row-cols-1 row-cols-md-2 g-4">
        {/* Wartość asortymentu */}
        <div className="col">
          <div className="card shadow rounded-4 h-100">
            <div className="card-body">
              <h5 className="card-title">🤲 Łączna wartość asortymentu</h5>
              <p className="display-6 fw-bold text-success text-break">
                {totalValue.toLocaleString("pl-PL", {
                  style: "currency",
                  currency: "PLN",
                })}
              </p>
              <p className="mt-2 mb-0 text-muted">
                📦 Liczba produktów w bazie: <strong>{products.length}</strong>
              </p>
              <p className="mb-0 text-muted">
                ❌ Brak na stanie: <strong>{products.filter(p => Number(p.quantity) === 0).length}</strong>
              </p>
              <p className="mb-0 text-muted">
                ✅ Na stanie: <strong>{products.filter(p => Number(p.quantity) > 0).length}</strong>
              </p>
            </div>
          </div>
        </div>


        {/* Top 10 najdroższych */}
        <div className="col">
          <div className="card shadow rounded-4 h-100">
            <div className="card-body">
              <h5 className="card-title">💰 Top 10 najdroższych produktów</h5>
              <ol className="list-group list-group-numbered">
                {top10.map((p) => (
                  <li
                    key={p.id}
                    className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                  >
                    <Link
                      to={`/products/${p.id}`}
                      className="text-decoration-none flex-grow-1 me-2"
                    >
                      {p.name}
                    </Link>
                    <span className="badge bg-primary rounded-pill">
                      {Number(p.price || 0).toFixed(2)} zł
                    </span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
